<p-card [header]="'End of ' + (isRlc ? 'Shift' : 'Day') + ' TPM Inventory'">
  <p-table [value]="tpmInventoryItems" dataKey="controls.id.value" [rowTrackBy]="rowTrackBy" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th>TPM</th>
        <th>Product<span class="required">*</span></th>
        <th>Floor <br> Inventory<span class="required">*</span></th>
        <th>Partial Trailer <br> Inventory<span class="required">*</span></th>
        <th>Delete</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
      <tr [formGroup]="rowData">
        <td>
          <div class="centered">
            {{rowData.displayOrder}}
          </div>
        </td>
        <td>
          <p-dropdown
            [options]="products"
            formControlName="productId"
            appendTo="body"
            name="product"
            [required]
            [filter]="true"
            [editable]="false"
            [resetFilterOnHide]="true">
          </p-dropdown>
        </td>
        <td>
          <input pInputText type="number"
            formControlName="pieces1"
            style="width:100%"
            name="pieces1"
            required
            lib-numeric>
        </td>
        <td>
          <input pInputText type="number"
            formControlName="pieces2"
            style="width:100%"
            name="pieces2"
            required
            lib-numeric>
        </td>
        <td>
          <confirmation-button
            [iconsOnly]="true"
            actionIcon="pi pi-times"
            actionText="Delete"
            confirmIcon="pi pi-times"
            confirmText="Delete"
            cancelIcon="pi pi-minus-circle"
            cancelText="Cancel"
            [disabled]="rowData.disabled"
            (actionConfirmed)="deleteTpmInventoryRow(rowData)">
          </confirmation-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="5" class="centered">
          No data available
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-rowData>
      <tr [formGroup]="tpmInventoryForm">
        <td class="centered">
          {{nextIndex}}
        </td>
        <td>
          <p-dropdown [options]="products" [required] placeholder="-- Select Product --" inputId="productID" appendTo="body"
            class="form-control" name="productId" [filter]="true" [editable]="false" [resetFilterOnHide]="true" formControlName="productId">
          </p-dropdown>
          <error-block [field]="tpmInventoryForm.controls.productId" [messages]="{
              required: 'Product is required.'
            }">
            </error-block>
        </td>
        <td>
          <input type="number" lib-numeric pInputText id="pieces1" required name="pieces1" class="form-control" formControlName="pieces1"/>
          <error-block [field]="tpmInventoryForm.controls.pieces1" [messages]="{
            required: 'Floor Inventory is required.'
          }">
          </error-block>
        </td>
        <td>
          <input type="number" lib-numeric pInputText id="pieces2" required name="pieces2" class="form-control" formControlName="pieces2"/>
          <error-block [field]="tpmInventoryForm.controls.pieces2" [messages]="{
            required: 'Partial Trailer Inventory is required.'
          }">
          </error-block>
        </td>
        <td>
          <button type="button" pButton
            icon="pi pi-plus"
            iconPos="left"
            (click)="saveTPMI();"
            label="Add"
            [disabled]="tpmInventoryForm.disabled"
            [ngClass]="{ 'p-state-disabled': !tpmInventoryForm.valid }"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
